import { color } from '@nuvolo/nuux-theme/utils';
import styled from 'styled-components';
import { isDarkTheme } from '#/common/utils/themeDetection';
import { borderRadius } from '#/common/hooks/useClientTheme';

const Styles = styled.div`
  /* Invert calendar icon when dark theme is active */
  ${({ theme }) => {
    if (isDarkTheme(theme)) {
      return `
        .dx-dropdowneditor-icon::before {
          filter: invert(1);
        }
      `;
    }
    return '';
  }}

  .dx-form {
    /* max-width: 1002px; */
    width: 100%;
    margin: 0 auto;

    .dx-texteditor.dx-editor-outlined,
    .dx-htmleditor.dx-htmleditor-outlined,
    .dx-lookup {
      background-color: transparent !important;
      &.dx-state-readonly .dx-texteditor-input,
      &.dx-state-readonly .dx-htmleditor-content *,
      &.dx-state-readonly .dx-lookup-field {
        cursor: default !important;
        color: ${color('ui', 'dark3', 0.5)} !important;
      }
    }

    .dx-htmleditor.dx-htmleditor-outlined {
      padding: 0 !important;
    }

    .dx-numberbox input {
      text-align: right;
    }

    .dx-box {
      .dx-item.dx-box-item {
        .dx-item-content.dx-box-item-content {
          justify-content: center;

          .dx-field-item {
            padding-top: 20px;
            padding-left: 0;
            padding-right: 0;

            &.dx-first-row {
              padding-top: 0;
            }
          }
        }
      }
    }

    .nuvo-form-actions {
      .dx-box.dx-collection {
        display: flex;
        flex-direction: row !important;
        gap: 12px;
        padding-bottom: 20px;

        .dx-item.dx-box-item {
          flex-grow: initial !important;

          .dx-field-item {
            padding: 0;
          }
        }
      }
    }

    .nuvo-form-actions {
      position: absolute;
      top: 0;
      right: 0;
      padding-top: 32px !important;
      padding-right: 24px !important;
      margin: 0 !important;

      .dx-collection {
        height: 40px !important;
        line-height: 40px !important;
        margin: 0 !important;
        padding: 0 !important;
      }
    }

    .nuvo-form-actions-mobile {
      .dx-collection {
        gap: 8px !important;
      }
    }

    .tmm-section-no-reset-margin-padding {
      padding: 0 !important;
      margin: 0 !important;
    }

    .tmm-section-no-background,
    .tmm-section {
      border: 1px solid ${color('primary', 'light')} !important;
      border-radius: 20px;
      padding: 20px !important;
      background-color: ${color('custom', 'formGroupBackground')};
      margin: 48px 16px 16px 16px;
      position: relative;

      .dx-field-item-label-text {
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: ${color('primary', 'dark')};
        height: 70px;
        margin-bottom: 6px;
      }

      .dx-textbox,
      .dx-texteditor,
      .dx-htmleditor.dx-htmleditor-outlined {
        box-shadow: none !important;
      }

      input,
      textarea,
      .dx-htmleditor,
      .dx-lookup-field {
        border: 1px solid ${color('custom', 'formInputBorder')};
        border-radius: ${borderRadius?.s};
        padding: 12px 16px;
        background-color: ${color('custom', 'formInputBackground')} !important;

        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: ${color('primary', 'dark')};
      }
      img {
        aspect-ratio: 4 / 3 !important;
        height: 100% !important;
        object-fit: contain;
      }

      .dx-form-group-caption {
        position: absolute;
        top: -40px;
        left: 0;
        font-size: 20px;
        font-weight: 500;
        line-height: 26px;
        height: 26px;
        color: ${color('primary', 'dark')};
        padding: 0;
      }

      .hide-label {
        & > div > div {
          color: ${color('custom', 'formImageWrapperBackground')};
          border-radius: 32px;
        }
        & > label {
          display: none !important;
        }
      }
    }
    .dx-placeholder {
      color: ${color('custom', 'formInputPlaceholderColor')};
      left: 6px;
    }
    .dx-texteditor.dx-editor-outlined.dx-state-disabled .dx-texteditor-input {
      color: ${color('custom', 'formDisabledInputColor')};
      & + .dx-placeholder {
        color: ${color('custom', 'mediumGray')};
      }
    }

    .tmm-section-no-background {
      background-color: transparent !important;
      border: none !important;
      padding: 0 !important;
    }

    .tmm-section-no-caption {
      margin: 16px !important;
    }

    .dx-field-item:has(.dx-state-readonly) > .dx-field-item-label .dx-field-item-label-text {
      color: ${color('custom', 'lightContrastText')} !important;
    }

    .currency-field > div > div > div:first-child {
      border-width: 0 !important;
      background-color: ${color('custom', 'inputIconBackground')};
      border-color: ${color('custom', 'formInputBorder')} !important;
      border-top-left-radius: 12px;
      border-bottom-left-radius: 12px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      font-weight: 400;
      font-size: 14px;
      width: 70px;
      padding: 12px 20px;
      color: ${color('custom', 'contrastText')};
      text-align: center !important;
    }

    .currency-field input {
      border: 1px solid ${color('custom', 'formInputBorder')} !important;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-top-right-radius: 12px;
      border-bottom-right-radius: 12px;
      color: ${color('custom', 'contrastText')};
      text-align: left;
      padding-top: 13px;
      padding-bottom: 13px;
    }

    .reference-field input,
    .date-box-field input,
    .dropdown-field input,
    .number-field input {
      width: 100% !important;
      padding-right: 60px !important;
      position: relative;
    }

    .text-area-field textarea.dx-texteditor-input {
      resize: vertical;
    }

    .reference-field .dx-texteditor-buttons-container,
    .date-box-field > div > div > div > div > div:nth-child(2),
    .dropdown-field > div > div > div > div > div:nth-child(2),
    .number-field > div > div > div > div:nth-child(2),
    .currency-field > div > div > div > div > div > div:nth-child(2) {
      position: absolute;
      margin: 0;
      right: 0;
      height: 100%;
    }

    .reference-field .dx-texteditor-buttons-container,
    .date-box-field > div > div > div > div > div:nth-child(2),
    .dropdown-field > div > div > div > div > div:nth-child(2),
    .number-field > div > div > div > div:nth-child(2) {
      width: 60px;
    }

    .currency-field > div > div > div > div > div > div:nth-child(2) {
      width: 36px;
    }

    .reference-field .dx-texteditor-buttons-container {
      width: 60px;
      padding-right: 12px;
      &:nth-child(n + 2) {
        padding-right: 0px;
      }
    }

    .reference-field .dx-clear-button-area {
      .dx-icon-clear {
        mask: url('/assets/xmark-solid-full.svg') no-repeat center;
        mask-size: contain;
        background-color: ${color('custom', 'constLightGray')} !important;
      }
    }

    .reference-field input {
      padding-left: 50px !important;
    }

    .reference-field .dx-placeholder {
      padding-left: 40px !important;
    }

    .reference-field > div > div {
      position: relative !important;
    }

    /* Cards dropdown needs visible overflow for the dropdown menu */
    .cards-dropdown {
      overflow: visible !important;

      & > div,
      & > div > div,
      .dx-field-item-content {
        overflow: visible !important;
      }
    }

    /* Ensure form sections allow dropdown overflow */
    .tmm-section:has(.cards-dropdown),
    .tmm-section-no-background:has(.cards-dropdown) {
      overflow: visible !important;
    }

    .reference-field > div > div > div:first-child {
      position: absolute;
      left: 0;
      height: 100%;
      z-index: 100;
      background-color: ${color('custom', 'inputIconBackground')};

      border: 1px solid ${color('custom', 'formInputBorder')};
      border-top-left-radius: 12px;
      border-bottom-left-radius: 12px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      color: ${color('contrast', 'dark')};
      text-align: left;

      .dx-button {
        background-color: transparent !important;
      }

      .dx-button-content > div {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .reference-field .dx-texteditor-buttons-container > div,
    .number-field > div > div > div > div:nth-child(2) > div:nth-child(2),
    .date-box-field > div > div > div > div > div:nth-child(2) > div:nth-child(2),
    .dropdown-field > div > div > div > div > div:nth-child(2) > div:nth-child(2) {
      margin: 0 auto;
    }

    .dx-dropdowneditor-icon::before,
    .dx-dropdowneditor.dx-dropdowneditor-active .dx-dropdowneditor-icon::before {
      font-size: 0 !important;
      width: 24px;
      height: 24px;
      display: inline-block;
      position: relative;
      top: 2px;
      left: 0;
      background: url('/assets/angle-down-solid-full.svg') no-repeat;
      background-position: center;
      background-size: contain;
      color: transparent !important;
    }

    .date-box-field .dx-dropdowneditor-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      height: fit-content;
      position: relative;
    }

    .date-box-field .dx-dropdowneditor-icon::before {
      width: 20px;
      height: 20px;
      top: 4px;
      background: url('/assets/calendar-solid-full.svg') no-repeat;
    }

    /* Hide Chrome's native date input icon on mobile */
    .date-box-field input[type='date']::-webkit-calendar-picker-indicator,
    .date-box-field input[type='datetime-local']::-webkit-calendar-picker-indicator,
    .date-box-field input[type='time']::-webkit-calendar-picker-indicator {
      display: none !important;
      -webkit-appearance: none !important;
    }

    /* Fix NumberBox spin buttons layout */
    .dx-numberbox-spin-container {
      display: flex !important;
      flex-direction: column !important;
      width: 20px !important;
      height: 100% !important;
    }

    .dx-numberbox-spin-up,
    .dx-numberbox-spin-down {
      width: 100% !important;
      height: 50% !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      border: none !important;
      background: transparent !important;
      cursor: pointer !important;
    }

    .dx-numberbox-spin-up {
      border-bottom: none !important;
    }

    .dx-numberbox-spin-down {
      border-top: none !important;
    }
    .dx-numberbox {
      position: relative !important;
    }
    .dx-texteditor-input-container {
      position: relative !important;
    }

    /* Hide Chrome's native number input spinners */
    .dx-numberbox input[type='number']::-webkit-outer-spin-button,
    .dx-numberbox input[type='number']::-webkit-inner-spin-button {
      -webkit-appearance: none !important;
      margin: 0 !important;
    }

    .dx-numberbox input[type='number'] {
      -moz-appearance: textfield !important;
    }

    .dx-lookup {
      height: 100%;
    }

    .number-field .dx-numberbox-spin-up-icon::before,
    .currency-field .dx-numberbox-spin-up-icon::before {
      top: 75% !important;
    }

    .number-field .dx-numberbox-spin-down-icon::before,
    .currency-field .dx-numberbox-spin-down-icon::before {
      top: 25% !important;
    }

    .currency-field:has(.dx-invalid) > div > div > div:first-child,
    .reference-field:has(.dx-invalid) > div > div > div:first-child {
      background: ${color('accent', 'light')} !important;
      border: 1px solid ${color('error', 'middle')} !important;
    }

    .currency-field:has(.dx-invalid) {
      .dx-texteditor-input {
        border-left: none !important;
      }
      .dx-invalid-message-content {
        left: -70px !important;
      }
    }

    .dx-invalid {
      input,
      textarea,
      .dx-lookup-field {
        border: 1px solid ${color('error', 'light')} !important;
      }

      .dx-lookup-arrow::after,
      .dx-texteditor-input-container::after {
        display: none !important;
      }
    }
    .dx-invalid-message.dx-overlay-wrapper {
      visibility: visible;
      padding: 0 1px;
    }
    .dx-invalid-message > .dx-overlay-content {
      padding: 0 1px;
    }

    .dx-field-item:not(.dx-field-item-has-group):has(.dx-invalid) .dx-field-item-label-text {
      color: ${color('error', 'middle')};
    }
  }
`;

export default Styles;
